import Contact from './about--contact.js';

function About() {
	const aboutElement = document.querySelector('.about');
	const aboutGatomonodesignElement = aboutElement.querySelector('.about--gatomonodesign');
	const aboutContactElement = aboutElement.querySelector('.about--contact');
	const mainnavEntryElement = document.querySelector('.mainnav--entry-about');
	const mainnavEntryLinkElement = document.querySelector('.mainnav--entry-about .mainnav--entry--link');
	const pagesseparator = aboutElement.querySelector('.pages--separator');
	const contact = new Contact();

	pagesseparator.classList.add('no-overlay');

	function open() {
		BODY_ELEMENT.classList.add('body-about');
		MAINNAV_ELEMENT.classList.add('subpage');
		mainnavEntryLinkElement.classList.add('active');
		let hash = location.hash.substr(2);
		hash = hash.slice(hash.indexOf('/') + 1);
		if (hash === 'contact') {
			contact.open();
		} else {
			contact.close();
		}
	}

	function close() {
		resetTransitions();

		BODY_ELEMENT.classList.remove('body-about');
		MAINNAV_ELEMENT.classList.remove('subpage');
		mainnavEntryLinkElement.classList.remove('active');
		contact.close();
	}

	function resetTransitions() {
		mainnavEntryElement.style.transition = null;
		mainnavEntryElement.style.transform = null;
	}

	function animateEarth(e) {
		let element;

		if (e && e.target) {
			element = e.target;
		} else {
			element = aboutGatomonodesignElement;
		}

		if (window.innerWidth >= 768) {
			if (BODY_ELEMENT.classList.contains('body-about')) {
				const y = -59 - element.scrollTop / 50;
			}

			if (element.scrollTop > 66) {
				pagesseparator.classList.remove('no-overlay');
			} else {
				pagesseparator.classList.add('no-overlay');
			}
		} else {
			pagesseparator.classList.remove('no-overlay');
		}
	}

	aboutGatomonodesignElement.addEventListener('scroll', animateEarth);
	aboutContactElement.addEventListener('scroll', animateEarth);
	window.addEventListener('resize', resetTransitions);

	animateEarth();

	this.open = open;
	this.close = close;
}

export default About;
